import styles from "./index.module.css"
import { getEventColor, overlaps } from "pagesV2/pro/Calendar/utils"
import PropTypes from "prop-types"
import EventBlock from "../../EventBlock"
import { useMemo } from "react"
import moment from "moment"

const RenderEventBlocks = ({ day, hour, cellEvents, timeOffForDay, setIsBookingModalOpen, setSelectedBookingId }) => {
  const isPastHour = useMemo(() => {
    const now = moment()
    if (day.isBefore(now, "day")) return true
    if (day.isAfter(now, "day")) return false
    return Number(hour) < now.hour()
  }, [day, hour])

  return (
    <div className={`${styles.timeGridCell} ${isPastHour ? styles.pastCalendarCell : ""}`}>
      {cellEvents?.map((ev) => {
        const { startMoment, endMoment } = ev
        const eventStartHour = startMoment?.hour() ?? 0
        const eventStartMin = startMoment?.minute() ?? 0
        const eventEndHour = endMoment?.hour() ?? 0
        const eventEndMin = endMoment?.minute() ?? 0
        // Calculate top offset as a percentage of the hour cell
        const topPct = (eventStartHour + eventStartMin / 60 - hour) * 100
        const durationHours = eventEndHour + eventEndMin / 60 - (eventStartHour + eventStartMin / 60)
        const heightPct = durationHours * 100
        // Find how many events share this exact start time
        const sameStartEvents = cellEvents.filter((e2) => e2.start === ev.start)
        const stackIdx = sameStartEvents.findIndex(
          (e2) => (e2.id || e2.title + e2.start + e2.end) === (ev.id || ev.title + ev.start + ev.end)
        )
        const stackOffset = stackIdx * 12 // px offset for stacking
        const eventColor = getEventColor(ev.payment_status)
        const conflict =
          timeOffForDay?.allDay || (timeOffForDay?.ranges || []).some((r) => overlaps(startMoment, endMoment, r.start, r.end))
        return (
          <EventBlock
            key={ev.id || ev.title + ev.start + ev.end}
            event={ev}
            stackOffset={stackOffset}
            topPct={topPct}
            heightPct={heightPct}
            stackIdx={stackIdx}
            eventColor={eventColor}
            conflict={conflict}
            setIsBookingModalOpen={setIsBookingModalOpen}
            setSelectedBookingId={setSelectedBookingId}
          />
        )
      })}
    </div>
  )
}

RenderEventBlocks.propTypes = {
  day: PropTypes.object.isRequired,
  hour: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  cellEvents: PropTypes.array.isRequired,
  timeOffForDay: PropTypes.shape({
    allDay: PropTypes.bool,
    ranges: PropTypes.array
  }),
  setIsBookingModalOpen: PropTypes.func.isRequired,
  setSelectedBookingId: PropTypes.func.isRequired
}

export default RenderEventBlocks
